import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import type { POI } from '../models/POI'
import { useGetListPOIQuery } from '../services/tenantService'
import { setPoiList as slicePoiListSet } from '../features/poiSlice'
interface POILoaderProps {
  tenantName: string
  retorikName: string
}
const POILoader = (props: POILoaderProps): JSX.Element => {
  const [poiList, setPoiList] = useState<POI[]>([])
  const dispatch = useDispatch()

  const {
    data: poi,
    error: errorPoi,
    isLoading: isLoadingPoi
  } = useGetListPOIQuery(props.retorikName)

  useEffect(() => {
    console.log(poi, errorPoi, props.tenantName)
    if (!isLoadingPoi && poi && !errorPoi) {
      setPoiList(poi)
    } else if (errorPoi) {
      // temporary get mock tenants from error
      setPoiList(errorPoi as POI[])
    }
  }, [poi, isLoadingPoi])

  useEffect(() => {
    dispatch(slicePoiListSet({ poiList: poiList }))
  }, [poiList])

  return <></>
}

export { POILoader }
